import Vue from 'vue'
import App from './App.vue'
import store from './store'
import './registerServiceWorker'
import router from './router/index'
import axios from './api/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'


Vue.use(ElementUI)
let Bus = new Vue()

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.Bus = Bus

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
